export default __webpack_public_path__ + "src/static/docs/pdf-arc-rights.pdf";